'use strict';

/* eslint-disable indent */

var formErrors = require('theme/js/checkout/formErrors');
import { callTurnstile } from 'shared/js/turnstileWidget';

function initB2bRegistration() {
    $(document).on('click', '.same-as-delivery label', function () {
        var sameAsDelivery = document.querySelector('.same-as-delivery');
        if (!sameAsDelivery) return;
        var copy = sameAsDelivery.classList.contains('copied');

        if (!copy) {
            $('.invoiceAddress').val($('.deliveryAddress').val());
            $('.invoiceCity').val($('.deliveryCity').val());
            $('.invoicePostalCode').val($('.deliveryPostalCode').val());
            $('.invoiceEmail').val($('.deliveryEmail').val());
        }

        $(sameAsDelivery).toggleClass('copied');
    });

    $(document).on('submit', '.b2bregistration-form', function (e) {
        e.preventDefault();

        var form = $(this);
        var formEl = this;
        var formData = form.serialize();
        formErrors.clearPreviousErrors('.b2bregistration-form');

        const registerB2bUser = function (turnstileResponse) {
            var data = (formData.replace(/&?cf-turnstile-response=[^&]*/g, '') + '&action=createaccount').replace(/^&/, '');
            if (turnstileResponse) {
                data += '&cf-turnstile-response=' + encodeURIComponent(turnstileResponse);
            }
            $.ajax({
                url: form.attr('action'),
                type: form.attr('method'),
                data: data,
                success: function (data) {
                    var successMessage = data.successMessage;
                    $('#b2bregistration-form--success-message').html(successMessage);
                    $('#b2bregistration-form--success-message').removeAttr('hidden');
                    $('#b2bregistration-form--error-message').attr('hidden', true);
                    $('[data-b2bregistration-form]').hide();
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $('body').offset().top
                    }, 500);
                },
                error: function (errorData) {
                    var responseJson = errorData.responseJSON;
                    var errorMessage;
                    switch (errorData.status) {
                        case 400:
                            var fieldErrors = responseJson && responseJson.fieldErrors;
                            if (fieldErrors.length) {
                                fieldErrors.forEach(function (error) {
                                    if (Object.keys(error).length) {
                                        formErrors.loadFormErrors('.b2bregistration-form', error);
                                    }
                                });
                            }
                            break;
                        case 500:
                            errorMessage = '';
                            if (responseJson.action == 'CSRF-AjaxFail') {
                                errorMessage = 'Session timed out. Please reload the page and try again.';
                            } else {
                                errorMessage = responseJson.serverErrors.join(', ');
                            }
                            $('#b2bregistration-form--error-message').html(errorMessage);
                            $('#b2bregistration-form--error-message').removeAttr('hidden');
                            break;
                        default:
                            errorMessage = 'An error has occured, please try again. If the problem persists please contact HSNG support.';
                            $('#b2bregistration-form--error-message').html(errorMessage);
                            $('#b2bregistration-form--error-message').removeAttr('hidden');
                    }
                    $('#b2bregistration-form--success-message').attr('hidden', true);
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $('body').offset().top
                    }, 500);
                }
            });
        };

        callTurnstile(registerB2bUser, formEl.querySelector('.register-turnstile-container'));

        return false;
    });
}

$(document).ready(function () {
    initB2bRegistration();
});

module.exports = { initB2bRegistration: initB2bRegistration };
